import { render } from "./MainBody.html?vue&type=template&id=f3bc3e2a&scoped=true"
import script from "./MainBody.vue?vue&type=script&lang=ts"
export * from "./MainBody.vue?vue&type=script&lang=ts"

import "./MainBody.css?vue&type=style&index=0&id=f3bc3e2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f3bc3e2a"

export default script